import React from 'react';

function TimeRangeCellRenderer({ data }) {
    return (
        <div className="flex items-center gap-1.5 h-full font-mono text-sm">
            <span>{data?.timeIni ?? '--'}</span>
            <span className="text-gray-400 font-sans text-xs">-</span>
            <span>{data?.timeEnd ?? '--'}</span>
        </div>
    );
}

export default TimeRangeCellRenderer;
